import React from "react"
import { useTranslation } from 'react-i18next'
import { Box, Typography } from "@mui/joy"
import { Text } from "../Typography";
import JSONPretty from 'react-json-pretty';
import { Icon } from "src/mtska-frontend-app-component/assets";

const SectionMessageBlock = (params) => {
    const { t } = useTranslation();

    const className = (typeof params.className != typeof undefined) ? params.className + " form-element form-message-block" : "form-element form-message-block";
    return <Box className={className} >
        <Icon icon={params.icon} />
        <Typography level={'title-lg'}  children={t(params.title)} />
        <Typography level={'body-lg'} children={t(params.paragraph)} />
    </Box>
}

export default SectionMessageBlock